module.exports = __webpack_public_path__ + "resources/sass/fn/fonts/OpenSans-ExtraBoldItalic-webfont.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/resources/sass/fn/fonts/OpenSans-ExtraBoldItalic-webfont.ttf
// module id = 383
// module chunks = 0